
import React, { useImperativeHandle, useRef, useState, forwardRef, useEffect } from 'react';
import { Modal } from 'bootstrap';
import { useSelector } from 'react-redux';
import HttpAPICall from '../../../services/HttpAPICall';
import { IAM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import Loader from '../../../components/ui/Loader/Loader';
import moment from 'moment';
import TapHelper from '../../../services/TapHelper';

const AssetProductivityTargetDetailModal = forwardRef((props, ref) => {

    let DetailUrl = IAM_API_BASE_URL_2 + "/report/configuration_wise_asset_productivity_detail";

    const detailModalElem = useRef(null);
    const detailModal = useRef(null);
    const [detail_loading, setDetail_loading] = useState([]);
    const [siteDetailData, setSiteDetailData] = useState(null);
    const [siteDetailConfigurationData, setSiteDetailConfigurationData] = useState(null);
    const access_token = useSelector(state => state.auth.access_token);

    useImperativeHandle(ref, () => ({
        initModalHandler: (configurationDetail, id, dateRange) => {
            
            if (!detailModal.current) {
                detailModal.current = new Modal(detailModalElem.current, {
                    keyboard: false,
                    backdrop: 'static',
                });
            }
            detailModal.current.show();
            setSiteDetailConfigurationData({...configurationDetail, id, dateRange});
        }
    }));
    useEffect(() => {
        if(siteDetailConfigurationData) {
            loadDetailData(siteDetailConfigurationData.id, siteDetailConfigurationData.dateRange);
        }
    }, [siteDetailConfigurationData])


    const loadDetailData = (id, dateRange) => {
        setDetail_loading(true)

        const params = {
            date_range: moment(dateRange || new Date()).format('YYYY-MM-DD'),
        };

        HttpAPICall.withAthorization("GET", `${DetailUrl}/${id}`, access_token, params, {}, (response) => {
            let respData = response.data.data;
            
            const deviation = respData.target_per_day > 0 && siteDetailConfigurationData.total_actual_productivity > 0
                    ? (((siteDetailConfigurationData.total_actual_productivity / respData.target_per_day) * 100) - 100)
                    : 0;
            setSiteDetailData({...respData, deviation, total_actual_productivity : siteDetailConfigurationData.total_actual_productivity});
        }).then(() => {
            setDetail_loading(false)
        });
    }
    const modalClose = () => {
        setSiteDetailConfigurationData(null);
    }
    return (
        <div className="modal fade" id="AssetProductivityTargetDetailModal" tabIndex="-1" ref={detailModalElem} >
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{siteDetailConfigurationData ? siteDetailConfigurationData.configuration_name : ''} ({siteDetailConfigurationData ? moment(siteDetailConfigurationData.dateRange).format('DD-MMM-YYYY') : ''})</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={modalClose}></button>
                    </div>
                    <div className="modal-body">
                        <div className="table-responsive" >
                            <table className="table table-sm table-bordered align-middle bg-white">
                                <thead className="align-middle table-secondary">
                                    <tr className='text-center'>
                                        <th style={{ width: "5%" }}>Total Actual Productivity</th>
                                        <th style={{ width: "5%" }}>Per Day Target</th>
                                        <th style={{ width: "8%" }}>Deviation (%)</th>
                                        <th style={{ width: "9%" }}>Cumulative Progress till date</th>
                                        <th style={{ width: "9%" }}>Cumulative Progress (Lifetime Cumulative)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {detail_loading ? (
                                        <tr>
                                            <td className='text-center' colSpan={6}>
                                                <Loader />
                                            </td>
                                        </tr>
                                    ) : (
                                        (siteDetailData ?
                                            <tr className="text-end">
                                                    <td>
                                                        {TapHelper.numberFormatter(siteDetailData.total_actual_productivity, 2)}
                                                    </td>
                                                    <td>
                                                        {siteDetailData.target_per_day ? TapHelper.numberFormatter(siteDetailData.target_per_day, 2) : 0}
                                                    </td>
                                                    <td>
                                                        {TapHelper.numberFormatter(siteDetailData.deviation, 2)}
                                                    </td>
                                                    <td>
                                                        {TapHelper.numberFormatter(siteDetailData.cumulative_progress_till_date, 2)}</td>
                                                    <td>
                                                        {TapHelper.numberFormatter(siteDetailData.lifetime_cumulative, 2)}
                                                    </td>
                                                </tr>
                                        
                                            : (
                                                <tr>
                                                    <td className='text-center' colSpan={6}>No Records Found</td>
                                                </tr>
                                            )
                                        )
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={modalClose}>Close</button>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default AssetProductivityTargetDetailModal;
